import { render, staticRenderFns } from "./CopyableComponent.vue?vue&type=template&id=2ef43240&"
import script from "./CopyableComponent.vue?vue&type=script&lang=js&"
export * from "./CopyableComponent.vue?vue&type=script&lang=js&"
import style0 from "./CopyableComponent.vue?vue&type=style&index=0&id=2ef43240&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports